import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserModel} from '../../../services/user/user.model';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Store} from '@ngxs/store';
import {Subscription} from 'rxjs';
import {MustMatch} from '../../../validators/mustMatch.validator';
import {ValidateUserNameNotTaken} from '../../../validators/usernameNotTaken.validator';
import {UserService} from '../../../services/user/user.service';
import {DeleteUser, UpdateUser, UpdateUserPassword} from '../../../../state/actions/appState.users.actions';
import {RequestConfirmation} from '../../../../state/actions/appState.actions';
import {DeletePaycard, ResetPaycardPin} from '../../../../state/actions/appState.paycards.actions';
import {tap} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {ConfirmModalComponent} from '../confirm/confirm-modal.component';

@Component({
  selector: 'app-account-settings-modal',
  templateUrl: './update-user-modal.component.html',
  styleUrls: ['./update-user-modal.component.scss']
})
export class UpdateUserModalComponent implements OnInit, OnDestroy {
  @Input() user: UserModel;

  passwordForm: FormGroup;
  informationForm: FormGroup;

  private subs: Subscription[] = [];

  constructor(
    private activeModal: NgbActiveModal,
    private ngbModal: NgbModal,
    private translate: TranslateService,
    private fb: FormBuilder,
    private store: Store,
    private cd: ChangeDetectorRef,
    private userService: UserService
  ) {
  }

  ngOnInit(): void {
    this.passwordForm = this.fb.group({
      password: new FormControl(
        '', [Validators.required, Validators.minLength(5)]),
      repeat: new FormControl(
        '', [Validators.required])
    }, {
      validator: MustMatch('password', 'repeat')
    });
    this.subs.push(
      this.passwordForm.valueChanges.subscribe(() => {
        this.cd.detectChanges();
      })
    );

    this.informationForm = this.fb.group({
      userName: new FormControl(
        this.user ? this.user.userName : '', [Validators.required],
        [ValidateUserNameNotTaken.validate(this.userService, [this.user.userName])]),
      firstName: new FormControl(
        this.user ? this.user.firstName : '', [Validators.required]),
      lastName: new FormControl(
        this.user ? this.user.lastName : '', [Validators.required]),
      admin: new FormControl(false)
    });
    this.subs.push(
      this.informationForm.valueChanges.subscribe(() => {
        this.cd.detectChanges();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  closeModal() {
    this.activeModal.close(this.user);
  }

  onDeleteUser() {
    this.store.dispatch(new RequestConfirmation('shared.modals.user-delete.description', {userName: this.user.userName})).toPromise()
      .then(() => {
        this.store.dispatch(new DeleteUser(this.user.userName)).toPromise().then(() => this.activeModal.close());
      });
  }

  submitPassword() {
    this.store.dispatch(new UpdateUserPassword(this.passwordForm.getRawValue(), this.user.userName))
      .toPromise().then(() => this.closeModal());
  }

  submitInformation() {
    this.store.dispatch(new UpdateUser(this.informationForm.getRawValue(), this.user.userName))
      .toPromise().then(() => this.closeModal());
  }
}
